<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">

            <!-- 序号 -->
            <el-table-column align="left" label="序号" >
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span>{{scope.row.serial_number}}</span>
            </template>
            </el-table-column>

            <!-- 保/批单号 -->
            <el-table-column align="left" label="保/批单号" >
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span>{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 险种 -->
            <el-table-column align="left" label="险种" >
            <template slot-scope="scope">
                <span>{{ scope.row.insruance }}</span>
            </template>
            </el-table-column>

            <!-- 投保人名称 -->
            <el-table-column align="left" label="投保人名称" >
            <template slot-scope="scope">
                <span>{{ scope.row.applicant }}</span>
            </template>
            </el-table-column>

            <!-- 被保险人名称 -->
            <el-table-column align="left" label="被保险人名称" >
            <template slot-scope="scope">
                <span>{{ scope.row.insured }}</span>
            </template>
            </el-table-column>

          <!-- 实收日期 -->
          <el-table-column align="left" label="实收日期" >
            <template slot-scope="scope">
              <span>{{ scope.row.receipt_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
          </el-table-column>

            <!-- 实收保费金额 -->
            <el-table-column align="left" label="实收保费金额" >
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 应付手续费比例(%) -->
            <el-table-column align="left" label="应付手续费比例(%)" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate}}</span>
            </template>
            </el-table-column>

            <!-- 应付手续费-->
            <el-table-column align="left" label="应付手续费" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency }}</span>
            </template>
            </el-table-column>

        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-zi-jin',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>
